'use client'

import * as React from 'react'
import { ClipboardIcon } from 'lucide-react'

import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@ui/web/components'
import { typographyVariants } from '@ui/web/lib'
import { getStaticAssetUrl } from '@helper/utils/file'
import cn from '@config/tailwind/cn'

import { InClassUploadWorkModal } from './upload-work-modal'

export interface InClassFinishModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void | React.Dispatch<React.SetStateAction<boolean>>
  learnProgressId: string
  onSuccess?: () => void
}

export function InClassFinishModal({ open, onOpenChange, learnProgressId, onSuccess }: InClassFinishModalProps) {
  const [isUploadOpen, setIsUploadOpen] = React.useState(false)

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className='srd:max-w-lg'>
          <DialogHeader className='srd:sr-only'>
            <DialogTitle>Perlu izin guru pendamping</DialogTitle>
            <DialogDescription>Sambil menunggu, kamu bisa simpan hasil kerjamu.</DialogDescription>
          </DialogHeader>

          <div className='srd:flex srd:flex-col srd:items-center srd:gap-y-2 srd:text-center srd:text-neutral-black'>
            <img src={getStaticAssetUrl('illustration/foam.png')} alt='' height={108} draggable={false} />

            <h6 className={cn(typographyVariants({ variant: 'headline-sm' }))}>
              Ups, kamu perlu izin guru pendamping untuk melanjutkan
            </h6>

            <p className={cn(typographyVariants({ variant: 'body-md' }), 'srd:text-grey-100')}>
              Sambil menunggu, kamu bisa bantu simpan hasil kerjamu kalau sudah selesai.
            </p>

            <div className='srd:flex srd:flex-col srd:items-center srd:justify-center srd:gap-y-4 srd:w-full srd:mt-8'>
              <Button onClick={() => onOpenChange(false)}>Oke, aku tunggu saja</Button>

              <Button
                variant='outline'
                onClick={() => {
                  onOpenChange(false)
                  setIsUploadOpen(true)
                }}
              >
                <ClipboardIcon className='srd:w-4 srd:h-4 srd:mr-2' />
                Simpan hasil kerjaku
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <InClassUploadWorkModal
        open={isUploadOpen}
        onOpenChange={setIsUploadOpen}
        learnProgressId={learnProgressId}
        onSuccess={onSuccess}
      />
    </>
  )
}

export { InClassUploadWorkModal, InClassUploadWorkModalBase } from './upload-work-modal'
export type { InClassUploadWorkModalBaseProps } from './upload-work-modal'
export { CameraModal } from './camera-modal'
